module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-7-89572803375bbc08651115baa813b02d.png";